import { render, staticRenderFns } from "./BathroomCard.vue?vue&type=template&id=1481df71&"
import script from "./BathroomCard.vue?vue&type=script&lang=js&"
export * from "./BathroomCard.vue?vue&type=script&lang=js&"
import style0 from "./BathroomCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports